export default "__VITE_ASSET__4a8754e3__"